import { createStore } from "vuex";
import repoStore from "@/src/store/modules/repoStore";
import graphStore from "@/src/store/modules/graphStore";
import userStore from "@/src/store/modules/userStore";
import _ from "lodash-es";
import chatbotStore from "@/src/store/modules/chatbotStore";
import {
  GRAPH_API_TYPE,
  LOGIN_API_TYPE,
  WORKSPACE_API_TYPE,
  CELONIS_CONTENT_API_TYPE,
} from "@/src/model/apiTypes";

import { StudioApi } from "@/src/model/StudioApi";
import graphWizardStore from "./modules/graphWizardStore";
const studioApi = new StudioApi();

const store = createStore({
  modules: {
    repoStore,
    graphStore,
    chatbotStore,
    userStore,
    graphWizardStore
  },
  state: {
    loading: {},
    error: null,
  },
  mutations: {
    setLoading(state, { key, value }) {
      let loading = _.cloneDeep(state.loading);
      loading[key] = value;
      state.loading = null;
      state.loading = loading;
    },
    setError(state, error) {
      state.error = error;
    },
  },
  actions: {
    getEmsUrl: async ({ state }) => {
      return await studioApi.exec(CELONIS_CONTENT_API_TYPE.GET_EMS_URL);
    },
    getCelonisApiStatus: async ({ state }) => {
      return await studioApi.exec(CELONIS_CONTENT_API_TYPE.GET_CELONIS_API);
    },
    updateCelonisApi: ({ state }, payload) => {
      return studioApi.exec(
        CELONIS_CONTENT_API_TYPE.UPDATE_CELONIS_API,
        payload
      );
    },
  },
  getters: {
    getError: (state) => state.error,
    isLoading: (state) => (keys) => {
      if (!_.isArray(keys)) {
        keys = [keys];
      }
      for (const i in keys) {
        const key = keys[i];
        if (state.loading.hasOwnProperty(key) && state.loading[key]) {
          return true;
        }
      }
      return false;
    },
    disableInteraction: (state, getters) => {
      return getters.isLoading([
        GRAPH_API_TYPE.DELETE_GRAPH,
        WORKSPACE_API_TYPE.DELETE_WORKSPACE,
        WORKSPACE_API_TYPE.ADD_WORKSPACE,
        WORKSPACE_API_TYPE.GET_WORKSPACES,
      ]);
    },
  },
});

// export the store
export default store;
